<template>
  <div>
    <div v-if="isModalOpen && !followUpOpen" class="modal fade show d-block" tabindex="-1" role="dialog" @click.self="closeModal">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Perfil do Associado</h5>
            <button type="button" class="close" @click="closeModal" aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body info-card-scroll">
            <div>
              <div class="row">
                <div class="col-md-4">
                  <div class="row">
                    <div>
                      <div class="info-card">
                        <div class="info-header text-center">
                          <div class="avatar mx-auto" @click="handleOpenPersonDetails()">
                            {{ personData.nomeAssociado ? personData.nomeAssociado.charAt(0) : '' }}
                          </div>
                          <h3 class="clickable" @click="handleOpenPersonDetails()">
                            {{ personData.nomeAssociado || 'Usuário Desconhecido' }}
                          </h3>
                        </div>
                        <div class="row space-b2">
                          <div class="col-md-6">
                            <p>
                              <i class="fas fa-user"></i><strong> Tipo: </strong>
                              {{ getTipoPessoa(personData.document) }}
                            </p>
                            <p>
                              <i class="fas fa-id-card"></i> &nbsp;
                              <strong>
                                {{ personData ? getTipoPessoa(personData.document) == 'PF' ? 'CPF' : 'CNPJ' : '' }}:&nbsp;
                              </strong>
                              {{ onFormatDocument(personData.document) || 'Documento não informado' }}
                            </p>
                            <p>
                              <i class="fas fa-id-card"></i> &nbsp;
                              <strong>{{ $t('associates.number') }} :&nbsp;</strong>
                              {{ personData ? personData.numId : '' }}<strong></strong>
                            </p>
                            <p>
                              <i class="fas fa-calendar"></i><strong> Data de Nascimento:</strong>
                              {{ formatDate(personData.dataNascimento) }}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <i class="fas fa-building"></i><strong> PA:</strong>
                              {{ personData.nomePA ? personData.nomePA + ' ' + personData.numeroPA : 'Não informado' }}
                            </p>
                            <p>
                              <i class="far fa-calendar-check"></i><strong> Gerente:</strong>
                              {{ personData.nomeGerente || 'Não informado' }}
                            </p>
                            <p>
                              <i class="far fa-calendar-check"></i><strong> Agente de Relacionamento:</strong>
                              {{ personData.gerenteRelacionamento || 'Não informado' }}
                            </p>
                            <p>
                              <i class="fas fa-file-contract"></i><strong> Última Renovação:</strong>
                              {{ formatDate(personData.ultimaRenovacao) }}
                            </p>
                          </div>
                        </div>

                        <div v-if="personData.matriculas && personData.matriculas.length">
                          <h4>Matrículas</h4>
                          <div v-for="(matricula, index) in personData.matriculas" :key="index" class="mb-3">
                            <p><i class="fas fa-wallet"></i><strong> Número Conta:</strong> {{ matricula.numMatricula }}</p>
                            <p><i class="fas fa-calendar"></i><strong> Data:</strong> {{ formatDate(matricula.dataMatricula) }}</p>
                            <p><i class="fas fa-check"></i><strong> Situação:</strong> {{ matricula.situacaoMatricula }}</p>
                            <p><i class="fas fa-funnel-dollar"></i><strong> Saldo Final:</strong> {{ formatValue(matricula.saldoFinalIntegralizadoDiario) }}</p>
                            <hr v-if="index < personData.matriculas.length - 1">
                          </div>
                        </div>
                        <p v-else>Nenhuma matrícula encontrada.</p>

                        <div v-if="pessoaRelacionada && pessoaRelacionada.length > 0 && getTipoPessoa(personData.document) === 'PJ'" class="mt-3">
                          <h4><i class="fas fa-users"></i> Sócios:</h4>
                          <ul class="list-unstyled">
                            <li v-for="socio in pessoaRelacionada" :key="socio.id" class="mb-1">
                              <i class="fas fa-user"></i> {{ socio.nomePessoaRelacionada }}
                            </li>
                          </ul>
                        </div>

                        <div class="associate__info__rows__container">
                          <div class="container_pendencias" style="justify-content: flex-start; gap: 1.5rem">
                            <div class="row_pendencias">
                              <i :class="'fas ' + (personData && checkTrueReturnBoolean(personData.isProdutorRural, 'indicadorProdutorRural') ? 'fa-check-circle' : 'fa-times-circle')"></i>
                              <p class="row__type">Produtor Rural</p>
                            </div>
                            <div class="row_pendencias">
                              <i :class="'fas ' + (personData && checkTrueReturnBoolean(personData.isMEI, 'mei') ? 'fa-check-circle' : 'fa-times-circle')"></i>
                              <p class="row__type">MEI</p>
                            </div>
                            <div class="row_pendencias">
                              <i :class="'fas ' + (personData && checkTrueReturnBoolean(personData.isPEP, 'indicadorPep') ? 'fa-check-circle' : 'fa-times-circle')"></i>
                              <p class="row__type">PEP</p>
                            </div>
                            <div class="">
                              <div>
                                <i class="fas fa-exclamation-circle"></i>
                                <strong>Possíveis Pendências:</strong>
                                <div class="possiveis-pendencias-container ml-4">
                                  <div class="row_pendencias">
                                    <i :class="'fas ' + (personData.possiveisPendencias && personData.possiveisPendencias.notificado ? 'fa-check-circle' : 'fa-times-circle')"></i>
                                    <p class="row__type">Protestado</p>
                                  </div>
                                  <div class="row_pendencias">
                                    <i :class="'fas ' + (personData.possiveisPendencias && personData.possiveisPendencias.ajuizado ? 'fa-check-circle' : 'fa-times-circle')"></i>
                                    <p class="row__type">Ajuizado</p>
                                  </div>
                                  <div class="row_pendencias">
                                    <i :class="'fas ' + (personData.possiveisPendencias && personData.possiveisPendencias.cobranca ? 'fa-check-circle' : 'fa-times-circle')"></i>
                                    <p class="row__type">Cobrança</p>
                                  </div>
                                  <div class="row_pendencias">
                                    <i :class="'fas ' + (personData.possiveisPendencias && personData.possiveisPendencias.impeditivaAbsoluta ? 'fa-check-circle' : 'fa-times-circle')"></i>
                                    <p class="row__type">Impeditiva Absoluta</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 col-sm-12 d-flex flex-column align-items-center">
                  <div class="mt-3 flex-fill">
                    <AssociateUtilizacaoProdutos :utilizacaoProdutos="[personData.utilizacaoProdutos]" :isBusyInfosFinance="true" :hideEye="false" />
                  </div>

                  <div class="info-card-center row mt-1 border rounded">
                    <div class="col-12">
                      <h5 class="text-center mb-3">Dados Financeiros</h5>
                      <div class="row row-cols-1 row-cols-md-2 g-3">
                        <div class="col">
                          <div class="text-center p-2 mb-3">
                            <i class="fas fa-chart-line"></i>
                            <strong>
                              <p class="space-t2"><span>{{ formatValue(personData.saldoInvestimento) }}</span></p>
                            </strong>
                            <p><strong>SALDO EM INVESTIMENTOS</strong></p>
                          </div>
                        </div>
                        <div class="col">
                          <div class="text-center p-2 mb-3">
                            <i class="fas fa-coins"></i>
                            <strong>
                              <p class="space-t2">
                                <span>
                                  {{ formatValue(personData.matriculas && personData.matriculas.length > 0 ? personData.matriculas[0].saldoFinalIntegralizadoDiario : 0) }}
                                </span>
                              </p>
                            </strong>
                            <p><strong>SALDO FINAL INTEGRALIZADO DIARIO</strong></p>
                          </div>
                        </div>
                        <div class="col">
                          <div class="text-center p-2 mb-3">
                            <i class="fas fa-credit-card"></i>
                            <strong>
                              <p class="space-t2">R$ <span>{{ formatValue(personData.endividamentoSFN) }}</span></p>
                            </strong>
                            <p><strong>SALDO EM ENDIVIDAMENTO SFN</strong></p>
                          </div>
                        </div>
                        <div class="col">
                          <div class="text-center p-2 mb-3">
                            <i class="fas fa-piggy-bank"></i>
                            <strong>
                              <p class="space-t2"><span>{{ formatValue(personData.totalSomaSaldoContaCorrente) }}</span></p>
                            </strong>
                            <p><strong>SALDO EM CONTA CORRENTE</strong></p>
                          </div>
                        </div>
                        <div class="col">
                          <div class="text-center p-2 mb-3">
                            <i class="fas fa-shield-alt"></i>
                            <strong>
                              <p class="space-t2"><span>{{ personData.classificacaoRisco || 'N/A' }}</span></p>
                            </strong>
                            <p><strong>CLASSIFICAÇÃO DE RISCO</strong></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 mt-2 d-flex flex-column">
                  <div class="d-flex justify-content-center mb-2">
                    <a href="#" @click.prevent="showFollowUpModal(personData.document)" class="btn btn-primary btn-sm fw-bold custom-activity-btn">
                      <i class="fas fa-clipboard-list"></i> REGISTRAR ATIVIDADES
                    </a>
                  </div>

                  <div class="info-card-center row mt-3 border rounded flex-fill">
                    <div class="col-12">
                      <h5 class="text-center mb-3">Oportunidades</h5>
                      <div class="col">
                        <div class="text-center p-2 mb-3">
                          <template v-if="personData.oportunidadeCartaoCreditoOutraInstituicao">
                            <i class="fas fa-credit-card"></i>
                            <strong>
                              <p class="space-t2">Oportunidade de Cartão de Crédito</p>
                            </strong>
                            <p>POSSUI CARTÃO E LIMITE MAS SEM UTILIZAÇÃO</p>
                          </template>
                          <template v-else>
                            <i class="fas fa-credit-card text-muted"></i>
                            <strong>
                              <p class="space-t2 text-muted">Sem oportunidade de Cartão de Crédito</p>
                            </strong>
                            <p class="text-muted">Nenhuma oportunidade de cartão de crédito identificada.</p>
                          </template>
                        </div>
                      </div>
                      <div class="col">
                        <div class="text-center p-2 mb-3">
                          <template v-if="personData.oportunidadeNaoPossuiSeguroResidencial">
                            <i class="fas fa-home"></i>
                            <strong>
                              <p class="space-t2">Oportunidade de Seguro Residencial</p>
                            </strong>
                            <p>NÃO POSSUI SEGURO RESIDENCIAL</p>
                          </template>
                          <template v-else>
                            <i class="fas fa-home text-muted"></i>
                            <strong>
                              <p class="space-t2 text-muted">Sem oportunidade de Seguro Residencial</p>
                            </strong>
                            <p class="text-muted">Nenhuma oportunidade de seguro residencial identificada.</p>
                          </template>
                        </div>
                      </div>
                      <div class="col">
                        <div class="text-center p-2 mb-3">
                          <template v-if="personData.oportunidadeNaoPossuiSeguroAutomovel">
                            <i class="fas fa-car-side"></i>
                            <strong>
                              <p class="space-t2">Oportunidade de Seguro Automóvel</p>
                            </strong>
                            <p>NÃO POSSUI SEGURO AUTOMÓVEL</p>
                          </template>
                          <template v-else>
                            <i class="fas fa-car-side text-muted"></i>
                            <strong>
                              <p class="space-t2 text-muted">Sem oportunidade de Seguro Automóvel</p>
                            </strong>
                            <p class="text-muted">Nenhuma oportunidade de seguro automóvel identificada.</p>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3 flex-fill">
                    <CobrancaQuadro :document="personData.document" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn custom-close-btn" @click="closeModal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
    <FollowUp
      ref="FollowUp"
      v-if="followUpOpen"
      :document="personData.document"
      :modal-title="'Detalhes do FollowUp'"
      :pessoaRelacionada="pessoaRelacionada"
      @close="handleCloseFollowUp"
    />
  </div>
</template>

<script>
import AssociateRepository from '@/shared/http/repositories/business/associate'
import AssociateUtilizacaoProdutos from '@/views/private/associate/components/AssociateUtilizacaoProdutos.vue'
import FollowUp from '@/components/nexum/components/modals/FollowUp.vue'
import CobrancaQuadro from '@/views/private/associate/components/AssociateCobranca.vue'
import boardTypes from '@/enums/enumBoardTypes.js'
import Tools from '../../tools/Tools.js'

export default {
  name: 'AssociadoResumo',
  components: { CobrancaQuadro, AssociateUtilizacaoProdutos, FollowUp },
  props: {
    document: {
      type: String,
      required: true
    },
    pessoaRelacionada: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isModalOpen: false,
      personData: {},
      boardTypes,
      followUpOpen: false
    }
  },
  mounted () {
    window.addEventListener('keydown', this.handleEscClose)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleEscClose)
  },
  methods: {
    async openResumoAssociado () {
      try {
        const response = await AssociateRepository.GetByDocumentResumo(this.document)
        this.personData = response.data
        this.isModalOpen = true
      } catch (err) {
        console.error('Erro ao buscar dados:', err)
      }
    },
    closeModal () {
      this.isModalOpen = false
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    },
    formatValue (value) {
      return value ? Tools.formatMoneyBR(value.toString()) : 'R$ 0,00'
    },
    formatDate (dateString) {
      if (!dateString) return 'Não informado'
      const date = new Date(dateString)
      const adjustedDate = new Date(date.getTime() + 3 * 60 * 60 * 1000)
      return adjustedDate.toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },
    handleOpenPersonDetails () {
      const url = this.$router.resolve({
        name: 'AssociatePage',
        params: {
          associateId: this.personData.associadoId,
          backUrl: 'Associate'
        }
      }).href
      window.open(url, '_blank')
      this.closeModal()
    },
    getTipoPessoa (document) {
      return Tools.checkDocumentType(document)
    },
    showFollowUpModal (document) {
      if (!document) {
        console.warn('Documento não disponível.')
        return
      }
      this.personData.document = document
      this.followUpOpen = true
      this.$nextTick(() => {
        this.$refs.FollowUp.openModal()
      })
    },
    handleCloseFollowUp () {
      this.followUpOpen = false
    },
    checkTrueReturnBoolean (value, debug) {
      let result

      if (!value) {
        // If value comes as Undefined or Null
        result = false
      } else if (isNaN(value)) {
        // If value comes as String
        result = value.toUpperCase() === 'SIM'
        // eslint-disable-next-line use-isnan
      } else if (parseInt(value) !== NaN) {
        // If value comes as number
        result = parseInt(value)
      } else if (typeof value === 'boolean') {
        // If value comes as boolean
        result = value
      } else {
        // Anything not mapped
        result = false
      }

      return result
    },
    handleEscClose (event) {
      if (this.isModalOpen && event.key === 'Escape') {
        this.closeModal()
      }
    }
  }
}
</script>

<style scoped>
/* Seu estilo permanece inalterado */
.info-card-scroll {
  max-height: 80vh;
  overflow-y: auto;
}
.info-card-center .text-center i {
  font-size: 1.5rem;
  margin-bottom: 5px;
  color: #04a791;
}
.modal.fade.show {
  background-color: rgba(0, 0, 0, 0.5);
}

.space-t2{
  margin-top: 5px !important;
}

.space-b2{
  margin-bottom: 5px;
}

.modal-body {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-height: 31.5rem;
}

.modal-xl {
  max-width: 95%;
}

.profile-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  margin-bottom: 20px;
}

.info-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.info-header.text-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.info-header i {
  font-size: 2rem;
  margin: 10px;
}

.avatar {
  width: 80px;
  height: 80px;
  background-color: #04a791;
  color: white;
  font-size: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 10px;
}

.info-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: left;
  overflow: auto;
}

.info-card-center {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 0px;
  padding: 8px;
  text-align: left;
  max-width: 530px;
  overflow: auto;
}

.avatar,
h3.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.avatar:hover,
h3.clickable:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

.custom-activity-btn {
  background-color: #1baca0;
  border-color: #1baca0;
  color: white;
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.custom-activity-btn:hover {
  background-color: #1baca0;
  border-color: #1baca0;
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.container_pendencias {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: 1.5rem;
}

.row_pendencias {
  display: flex;
  align-items: center;
}

/* NOVOS ESTILOS para o botão "Fechar" */
.custom-close-btn {
  background-color: #04A791; /* Cor verde que você indicou, similar ao do avatar */
  border-color: #04A791;
  color: white;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.custom-close-btn:hover {
  background-color: #027A6C; /* Um verde mais escuro para o hover */
  border-color: #027A6C;
  color: white; /* Garante que o texto continue branco no hover */
}

.possiveis-pendencias-container {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  align-items: flex-start;
}
.possiveis-pendencias-container .b-form-group {
  margin-bottom: 0.2rem;
}
.possiveis-pendencias-container .custom-control-label,
.possiveis-pendencias-container label {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  max-width: 100% !important;
  display: inline !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/modals/AssociadoResumo.vue